<template>
	<div class="node-path">
		<template v-if="targetGrandparent">
			<NodeName :node="targetGrandparent" />
			<span class="black--text"> / </span>
		</template>
		<template v-if="targetParent">
			<NodeName :node="targetParent" />
			<span class="black--text"> / </span>
		</template>
		<NodeName :node="node.target" />
	</div>
</template>

<script>
import _ from "lodash";

import NodeName from "./NodeName";

export default {
	components: { NodeName },

	props: {
		node: {
			type: Object,
			required: true,
		},
	},

	computed: {
		targetParent() {
			return _.get(this.node.target, "parentDevice");
		},

		targetGrandparent() {
			return _.get(this.targetParent, "parentDevice");
		},
	},
};
</script>
